import { Pagination } from "@mui/material";
import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const CommonPagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    if (value >= 1 && value <= totalPages) {
      onPageChange(value);
    }
  };

  return (
    <Pagination
      key={currentPage}
      count={totalPages}
      page={currentPage}
      onChange={handleChange}
      variant="outlined"
      shape="rounded"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: "10px",

        "& .Mui-selected": {
          background:
            "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
            color: "#fff",
        },
        "& .MuiPaginationItem-root": {
          border: "1px solid #E1E2E9",
        },
        "& .MuiPagination-ul": {
          gap: "5px",
        },
        "& .MuiPaginationItem-ellipsis": {
          border: "none",
        },
        "& .MuiPaginationItem-previousNext": {
          background: "#f9f9f9",
        },
      }}
    />
  );
};

export default CommonPagination;
